export default __webpack_public_path__ + "static/audience-0094f61b660b33124d1f9a622ca755f9.png";